export default __webpack_public_path__ + "static/media/e4.33d41ca8.png";